import { post } from './httpClient';

/**
 * Stripe subscription endpoints. Every call requires `orgId` — the server's
 * requirePermission('MANAGE_SUBSCRIPTION') middleware reads it from the
 * body, verifies the caller is the owner of that org per spec storage,
 * and looks up the org's subscription from
 * `privateData.orgSubscriptions[orgId]`.
 *
 * Callers must therefore pass the orgId of the org whose subscription
 * they're acting on (typically the orgId from the dashboard URL).
 */

/** Create a Stripe Checkout session for first-time paid subscription. */
export const createSubscriptionCheckout = (orgId, tier, interval = 'monthly') =>
  post(
    '/api/stripe/create-subscription-checkout',
    JSON.stringify({ orgId, tier, interval })
  );

/** Change subscription tier (upgrade or downgrade) with immediate effect. */
export const changeSubscriptionTier = (orgId, targetTier, interval = 'monthly') =>
  post(
    '/api/stripe/change-subscription-tier',
    JSON.stringify({ orgId, targetTier, interval })
  );

/** Cancel subscription. `immediate=false` cancels at period end (default). */
export const cancelSubscription = (orgId, immediate = false) =>
  post('/api/stripe/cancel-subscription', JSON.stringify({ orgId, immediate }));

/** Resume a subscription that's pending cancellation. */
export const resumeSubscription = orgId =>
  post('/api/stripe/resume-subscription', JSON.stringify({ orgId }));

/** Open Stripe Customer Portal for self-serve billing management. */
export const createCustomerPortalSession = (orgId, returnPath) =>
  post(
    '/api/stripe/create-customer-portal',
    JSON.stringify({ orgId, returnPath })
  );
